<template>
  <div id="hres88e">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :data="index"
            :nowLang="app.nowLang"
            :columns="columns[app.nowLang].index"
            :unLoadBool="true"
            :receivedStore="receivedHres88eIndex"
            :addEvent="addEvent"
            :editEvent="editEvent"
            :cancelEvent="cancelEvent"
            searchBoxAlias="hres88e" />

    <detail v-show="detailDisp"
            :labels="labels[app.nowLang]"
            :labelsButton="app.button[app.nowLang]"
            :nowLang="app.nowLang"
            :toggle="toggle"
            :indexSelected="indexSelected"
            :codempid="codempid"
            :descCodempid="app.currentUser.username[app.nowLang]"
            :detail="detail"
            :currentDtereq="currentDtereq"
            :currentNumseq="detail.numseq"
            :dropdowns="dropdowns"
            :searchIndex="searchIndex"
            :descCodapp="dash.descCodapp"
            :listFields="listFields"
            :eventBtn="eventBtn"
            :postHres88eDetailSave="postHres88eDetailSave" 
            :receivedHres88eDetailCodjob="receivedHres88eDetailCodjob" 
            />
  </div>

</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres88e/mutation-types'
import detail from 'components/hres88e/detail'
import moment from 'moment'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hres88e',
  data () {
    return {
      app: this.$parent.$parent.$parent,
      dash: this.$parent.$parent.$parent.$children[0],
      searchIndex: {
        dtereqst: moment().format('01/01/YYYY'),
        dtereqen: moment().format('DD/MM/YYYY')
      },
      currentDtereq: moment().format('DD/MM/YYYY'),
      eventBtn: ''
    }
  },
  created () {
    this.receivedHres88eColumnsLabels()
    this.receivedHres88eDropdowns()
    this.receivedHres88eLogicalListFields()
  },
  computed: {
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES88E_INDEX_DISP,
      detailDisp: types.GET_HRES88E_DETAIL_DISP,
      labels: types.GET_HRES88E_LABELS,
      index: types.GET_HRES88E_INDEX,
      columns: types.GET_HRES88E_COLUMNS,
      indexSelected: types.GET_HRES88E_INDEX_SELECTED,
      detail: types.GET_HRES88E_DETAIL,
      dropdowns: types.GET_HRES88E_DROPDOWNS,
      listFields: types.GET_HRES88E_LOGICAL_LISTFIELDS
    })
  },
  methods: {
    pageDetail (event) {
      switch (event) {
        case 'add':
          let searchIndex = {
            p_codempid_query: this.codempid,
            p_dtereq: moment().format('DD/MM/YYYY')
          }
          this.eventBtn = 'add'
          this.receivedHres88eCreate(searchIndex)
          this.toggle('detail')
          break
        case 'edit':
          if (this.indexSelected.numseq) {
            if (this.indexSelected.staappr === 'A' || this.indexSelected.staappr === 'Y' || this.indexSelected.staappr === 'N') {
              swal({
                title: constLabels('warningTitle'),
                text: constLabels('HR1490'),
                confirmButtonText: constLabels('ok')
              })
            }
            this.currentDtereq = this.indexSelected.dtereq
            let editParams = {
              p_codempid_query: this.codempid,
              p_dtereq: this.indexSelected.dtereq,
              p_numseq: this.indexSelected.numseq
            }
            this.eventBtn = 'edit'
            this.receivedHres88eDetail(editParams)
            this.toggle('detail')
          }
          break
        default:
          break
      }
    },
    addEvent (param) {
      this.pageDetail('add')
    },
    editEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail('edit')
    },
    cancelEvent (param) {
      this.setIndexSelected(param)
      if (this.indexSelected.staappr === 'P') {
        let sendParams = {
          p_codempid_query: this.codempid,
          p_dtereq: this.indexSelected.dtereq,
          p_numseq: this.indexSelected.numseq,
          p_staappr: this.indexSelected.staappr
        }
        this.postHres88eCancel({ sendParams, searchParams: this.searchIndex })
      } else if (this.indexSelected.staappr === 'C') {
        swal({
          title: constLabels('warningTitle'),
          text: constLabels('HR1506'),
          confirmButtonText: constLabels('ok')
        })
      } else {
        swal({
          title: constLabels('warningTitle'),
          text: constLabels('HR1490'),
          confirmButtonText: constLabels('ok')
        })
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES88E_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES88E_PAGE,
      receivedHres88eColumnsLabels: types.RECEIVED_HRES88E_COLUMNS_LABELS,
      receivedHres88eIndex: types.RECEIVED_HRES88E_INDEX,
      receivedHres88eCreate: types.RECEIVED_HRES88E_CREATE,
      receivedHres88eDetail: types.RECEIVED_HRES88E_DETAIL,
      receivedHres88eDropdowns: types.RECEIVED_HRES88E_DROPDOWNS,
      receivedHres88eLogicalListFields: types.RECEIVED_HRES88E_LOGICAL_LISTFIELDS,
      receivedHres88eDetailCodjob: types.RECEIVED_HRES88E_DETAIL_CODJOB,
      postHres88eDetailSave: types.POST_HRES88E_DETAIL_SAVE,
      postHres88eCancel: types.POST_HRES88E_CANCEL
    })
  },
  components: {
    detail
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?64535748